import { createSelector } from 'reselect';
import get from 'lodash/get';
import { selectPaperworkAppointmentIsAllConsentsSigned } from './paperwork-get-appointment-details';
import { PAPERWORK_SIGN_CONSENT } from '../../../constants/routes';

export const selectRootState = state => get(state, 'paperwork.common');

export const selectPaperworkGlobalPending = createSelector(
  selectRootState,
  state => get(state, 'pending'),
);

export const selectPaperworkFlowNextPagePathname = currentPathname =>
  createSelector(
    selectRootState,
    selectPaperworkAppointmentIsAllConsentsSigned,
    (state, isAllConsentsSigned) => {
      const pagesState = get(state, 'pages.allPages', []);
      const currentPageIndex = pagesState.indexOf(currentPathname);
      const nextPageIndex = currentPageIndex + 1;
      const nextPathname =
        nextPageIndex < pagesState.length ? pagesState[nextPageIndex] : null;

      if (
        nextPathname &&
        nextPathname.includes(PAPERWORK_SIGN_CONSENT) &&
        isAllConsentsSigned
      ) {
        const skipToNextPageIndex = nextPageIndex + 1;
        return skipToNextPageIndex < pagesState.length
          ? pagesState[skipToNextPageIndex]
          : null;
      }

      return nextPathname;
    },
  );

export const selectPaperworkFlowPrevPagePathname = currentPathname =>
  createSelector(
    selectRootState,
    selectPaperworkAppointmentIsAllConsentsSigned,
    (state, isAllConsentsSigned) => {
      const pagesState = get(state, 'pages.allPages', []);
      const currentPageIndex = pagesState.indexOf(currentPathname);
      const prevPageIndex = currentPageIndex - 1;
      const prevPathname =
        prevPageIndex >= 0 ? pagesState[prevPageIndex] : null;

      if (
        prevPathname &&
        prevPathname.includes(PAPERWORK_SIGN_CONSENT) &&
        isAllConsentsSigned
      ) {
        const skipToPrevPageIndex = prevPageIndex - 1;
        return prevPageIndex >= 0 ? pagesState[skipToPrevPageIndex] : null;
      }

      return prevPathname;
    },
  );

export const selectPaperworkFlowFormStepsCount = createSelector(
  selectRootState,
  state => {
    const steps = get(state, 'pages.formSteps');
    return steps.length;
  },
);

export const selectPaperworkFlowFirstFormStepPathname = createSelector(
  selectRootState,
  state => {
    const steps = get(state, 'pages.formSteps');
    return steps.length > 0 ? steps[0] : null;
  },
);

export const selectPaperworkFlowFormStepNumber = currentPathname =>
  createSelector(
    selectRootState,
    state => {
      const steps = get(state, 'pages.formSteps');
      return steps.indexOf(currentPathname) + 1;
    },
  );

export const selectPaperworkEligibilityResultId = createSelector(
  selectRootState,
  state => get(state, 'data.insuranceEligibilityResultId'),
);

export const selectPaperworkIsPlanNotListedSelected = createSelector(
  selectRootState,
  state => get(state, 'data.isPlanNotListedSelected'),
);

export const selectAdditionalInfoFormData = createSelector(
  selectRootState,
  state => get(state, 'data.additionalInfoFormData'),
);

export const selectPaperworkCameFromSubmitPage = createSelector(
  selectRootState,
  state => get(state, 'isCameFromSubmitPage'),
);

export const selectPaperworkValidating = createSelector(
  selectRootState,
  state => get(state, 'validating'),
);



// WEBPACK FOOTER //
// ./src/redux/paperwork/selectors/common.js